/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Header_Title_Number_SpacedInputs */



/**
* | output |
* | --- |
* | "Title #" |
*
* @param {Ccsl_Export_Header_Title_Number_SpacedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_header_title_number_spaced = /** @type {((inputs?: Ccsl_Export_Header_Title_Number_SpacedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Header_Title_Number_SpacedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Titre #")
	if (locale === "de") return /** @type {LocalizedString} */ ("Titel #")
	if (locale === "it") return /** @type {LocalizedString} */ ("Titolo n.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Заголовок #")
	if (locale === "es") return /** @type {LocalizedString} */ ("Título #")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("标题 ＃")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タイトル ＃")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शीर्षक #")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Título #")
	return /** @type {LocalizedString} */ ("Title #")
});